export class CalculationProgress {
  percent: number;
  message: string;

  constructor(percent: number, message: string) {
    this.percent = percent;
    this.message = message;
  }
}
